import {
    INoteBackend,
} from 'shared/models/sheet/Sheet';

export function rejectedReasonFormatter(notes?: INoteBackend[]): INoteBackend[] {
    return notes?.sort((a, b) => a.created_at < b.created_at ? 1 : -1) || [];
}
